export enum COMMENTS_ORDER_CATEGORY {
  BILLING = 'BILLING',
  GENERAL = 'GENERAL',
}
